import React, { useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import Loader from '../../Components/Loader'
import { useNavigate, useSearchParams } from 'react-router'
import { useTestimonialStore } from '../../store/useTestimonialStore'

const TestimonialForm = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [comment, setComment] = useState("")
    const [name, setName] = useState("")
    const [designation, setDesignation] = useState("")
    const [rating, setRating] = useState("")
    const [image, setImage] = useState(null)
    const [isFeatured, setIsFeatured] = useState('true')
    const [order, setOrder] = useState()

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const { getTestimonialById, postTestimonial, gettotaltestimonial } = useTestimonialStore()

    const getImageSrc = (img) => {
        if (!img) return null;
        if (typeof img === "string") {
            return img;
        }
        return URL.createObjectURL(img);
    };

    const handleSubmit = async () => {
        const data = {
            name: name, image: image, designation: designation, rating: rating || 0, id: id, comment: comment, isFeatured: isFeatured == 'true', order: Number(order)
        }
        setLoading(true)
        const res = await postTestimonial(data)
        setLoading(false)
        if (res) {
            navigate("/testimonial")
        }
        
    }

    const getRegisteredById = async () => {
        setLoading(true)
        let data = await getTestimonialById(id)
        if (data) {
            setOrder(data?.order)
            setName(data?.name)
            setDesignation(data?.designation)
            setRating(data?.rating)
            setComment(data?.comment)
            setImage(data?.avatar)
            setIsFeatured(data?.isFeatured ? 'true' : 'false')
        }
        setLoading(false)
    }

    const getTotalTestimonialFunction = async () => {
        const order = await gettotaltestimonial()
        let total = order ? order + 1 : 1
        setOrder(total)
    }

    useEffect(() => {
        if (id) {
            getRegisteredById()
        }
        else {
            getTotalTestimonialFunction()
        }
    }, [])

    return (
        <div>
            <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
                <Sidebar />
                <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                    <TopHeader pageName="Testimonial" />

                    <div id="content-container" className="flex-1 overflow-auto p-6">
                        <div>
                            <div id="project-form" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
                                <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                                    <h3>Add New Testimonial</h3>
                                    <button className="text-neutral-500 hover:text-neutral-700">
                                        <i className="fa-solid fa-times"></i>
                                    </button>
                                </div>
                                <Loader loading={loading}>
                                    <div className="p-6">
                                        <div className="grid grid-cols-3 gap-6 mb-6">
                                            <div>
                                                <label className="block text-sm text-neutral-700 mb-2">
                                                    Name
                                                </label>
                                                <input
                                                    type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm text-neutral-700 mb-2">
                                                    Designation
                                                </label>
                                                <input
                                                    type="text"
                                                    value={designation}
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm text-neutral-700 mb-2">
                                                    Rating
                                                </label>
                                                <input
                                                    type="text"
                                                    value={rating}
                                                    onChange={(e) => setRating(e.target.value)}
                                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-6 mb-6">
                                            <div>
                                                <label className="block text-sm text-neutral-700 mb-2">
                                                    Status
                                                </label>
                                                <select
                                                    value={isFeatured}
                                                    onChange={(e) => setIsFeatured(e.target.value)}
                                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                                >
                                                    <option value='true'>Active</option>
                                                    <option value='false'>Inactive</option>
                                                </select>
                                            </div>
                                            <div>
                                                <label className="block text-sm text-neutral-700 mb-2">
                                                    Project Order
                                                </label>
                                                <input
                                                    type="text"
                                                    value={order}
                                                    onChange={(e) => setOrder(e.target.value)}
                                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-6">
                                            <label className="block text-sm text-neutral-700 mb-2">Comment</label>
                                            <textarea
                                                rows="4"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                            ></textarea>
                                            <p className="text-sm text-gray-500 mt-1">
                                                {comment?.length || 0}/1000 characters
                                            </p>
                                        </div>

                                        {/* <div class="mb-6">
                                            <label class="block text-sm text-neutral-700 mb-2">Avatar</label>
                                            <div class="border-2 border-dashed border-neutral-300 rounded-md p-6 flex flex-col items-center justify-center">
                                                <i class="fa-solid fa-cloud-upload-alt text-3xl text-neutral-400 mb-2"></i>
                                                <p class="text-neutral-600 mb-2">Drag and drop an image here, or click to browse</p>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => setImage(e.target.files[0])}
                                                    class="hidden"
                                                    id="projectImage"
                                                />
                                                <label
                                                    htmlFor="projectImage"
                                                    class="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-md text-sm cursor-pointer"
                                                >
                                                    Select File
                                                </label>
                                                {image && <p class="mt-2 text-sm text-green-600">{image.name}</p>}
                                                <div className="w-44 h-26 flex items-center justify-center text-white text-xs mr-4">
                                                    {getImageSrc(image) ? (
                                                        <img
                                                            src={getImageSrc(image)}
                                                            alt="Hero"
                                                            className="w-full h-full object-cover"
                                                        />
                                                    ) : (
                                                        'No Image'
                                                    )}
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="flex justify-end space-x-3">
                                            <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                                                onClick={() => navigate(-1)}
                                            >Cancel</button>
                                            <button
                                                className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                                                onClick={() => handleSubmit()}
                                            >
                                                Save Testimonial
                                            </button>
                                        </div>
                                    </div>
                                </Loader>
                            </div>
                        </div>
                    </div >

                </div>
            </div>
        </div>
    )
}

export default TestimonialForm
